import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import map from 'lodash/map'
import size from 'lodash/size'

import i18n from '../i18n/i18n'

export class ApiError extends Error {
  status: number
  detail?: unknown

  constructor(fields: unknown, status: number, ...args: ErrorOptions[]) {
    super('', ...args)

    this.status = status

    if (isObject(fields) && 'detail' in fields) {
      this.detail = fields.detail
    }

    function t(value: string, options?: GenericObject) {
      return i18n.t(value, value, options)
    }

    function tArray(values: string[]) {
      return values.map((v) => t(v)).join('\n')
    }

    function tObject(values: { [key: string]: unknown }): string {
      if (values.error && values.detail && size(values) === 2) {
        return t(values.error as string, values.detail as GenericObject)
      }

      return map(values, (v) => {
        if (Array.isArray(v)) {
          return tArray(v)
        }

        return isObject(v)
          ? tObject(v as { [key: string]: unknown })
          : t(v as string)
      }).join('\n')
    }

    if (Array.isArray(fields)) {
      this.message = tArray(fields)
    } else if (isObject(fields)) {
      this.message = tObject(fields as { [key: string]: unknown })
    } else if (isString(fields)) {
      this.message = t(fields)
    }
  }
}
